export default __webpack_public_path__ + "static/media/timetakenicon.7432a018.png";